var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M17.492 13.514c-.176 0-.345.069-.47.19-.123.123-.194.288-.194.46l.015 2.068h-6.55l-5.56.012v-2.078c-.007-.168-.08-.327-.203-.443-.124-.116-.288-.181-.46-.181-.17 0-.335.065-.459.18-.123.117-.196.276-.203.444v2.082c0 .34.138.665.383.906.244.24.575.377.922.378h12.13c.348 0 .68-.136.926-.377.246-.24.384-.567.385-.908v-2.081c0-.086-.017-.17-.05-.25-.033-.078-.082-.15-.144-.21-.061-.061-.134-.11-.215-.142-.08-.033-.166-.05-.253-.05z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M11.06 14.005l1.627-2.137c.059-.077.095-.17.104-.266.008-.097-.01-.194-.054-.28-.045-.087-.112-.16-.196-.21-.084-.052-.18-.079-.28-.079h-.874l.029-7.027c0-1.16-1.523-1.027-1.523-.13v7.142l-.895.015c-.099 0-.195.027-.28.078-.083.051-.15.124-.195.21-.044.088-.063.184-.054.28.009.097.045.19.104.267l1.626 2.137c.05.067.114.12.19.158.074.038.157.057.24.057.085 0 .168-.02.242-.057.075-.037.14-.091.19-.158z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default ForwardRef;